module.exports = __webpack_public_path__ + "media/assets/menu-e191eab5449429fd03d6f3e4dbde55d3.svg";